import Axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../../_metronic/_helpers'
import { getServerCore, defaultSnackbarTimeout, RECAPTCHA_SITE_KEY } from '../../../../utils'
import { useDispatch } from 'react-redux'
import { showSuccessSnackbar } from '../../Snackbar/snackbar.action'
import ReCAPTCHA from 'react-google-recaptcha'

const { serverUrls } = getServerCore()
const authUrl = serverUrls.getAuthUrl()

const API_FAIL_MSG = {
  NOT_FOUND: 'Gold Bar not Found',
  CAPTCHA_FAIL: 'Captcha verification failure is regreted. please try later',
}

/******************* Component View Functions ******************/

const BoxView = ({ title, content }) => {
  return (
    <div className="col-xl-4 col-md-6 mb-1">
      <div className="pr_wt_box">
        <h6>{title}</h6>
        <h4 className="text-break">{content}</h4>
      </div>
    </div>
  )
}

const TableView = ({ owners }) => {
  return (
    <>
      <div className="col-md-12 d-flex align-items-center mt-10">
        <h4 className="fn_s_18 f-w-500 color_blk">Gold Bar Onwers List</h4>
        {/* <button type="button" className="btn btn-def btn-defv6 ml-auto">Buy More</button> */}
      </div>
      <div className="col-md-12 mt-3">
        <div className="mt-0">
          <Table hover responsive className="mb-0 default_table mrpdng_tbl">
            <thead>
              <tr>
                <th>Date</th>
                <th>Wallet Address</th>
                <th>Gold Owned (GRAMS)</th>
                <th>Tokens</th>
              </tr>
            </thead>
            <tbody>
              {owners?.length ? (
                owners.map((owners) => (
                  <tr key={owners._id}>
                    <td>{new Date(owners.timeStamp).toLocaleString()}</td>
                    <td>{owners.wallet}</td>
                    <td>{owners.units}</td>
                    <td>{+owners.tokens.toFixed(3)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="text-center">
                    No Onwers Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </>
  )
}

/********************** Main View Function *********************/

function GoldBarInfo() {
  const [isLoaded, setIsLoaded] = useState(false)
  const [goldBarData, setGoldBarData] = useState(null)
  const [apiFailMsg, setApiFailMsg] = useState(API_FAIL_MSG['NOT_FOUND'])

  const dispatch = useDispatch()

  const loadGoldData = async (token) => {
    try {
      const { data } = await Axios({
        method: 'GET',
        url: `${authUrl}/getGoldBarInfo/${params.serialNo}?response=${token}`,
      })

      if(data.responseCode === 404) setApiFailMsg(API_FAIL_MSG['NOT_FOUND'])
      if(data.responseCode === 400) setApiFailMsg(API_FAIL_MSG['CAPTCHA_FAIL'])

      if (data.responseCode === 200) setGoldBarData(data.responseData)
      else
        dispatch(
          showSuccessSnackbar(
            'error',
            data.responseMessage,
            defaultSnackbarTimeout,
          ),
        )
    } catch (err) {
      dispatch(
        showSuccessSnackbar('error', err.message, defaultSnackbarTimeout),
      )
    } finally {
      setIsLoaded(true)
    }
  }

  const handleOnchange = async (token) => loadGoldData(token)

  const params = useParams()
  return (
    <>
      <div className="bg-white">
        <div className="abt_sc_1 mt-5 mb-5">
          <div className="container container_frnt">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="top_img">
                  <img
                    alt=""
                    src={toAbsoluteUrl('/media/others/about_img.jpg')}
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="col-md-8 mt-20">
                <h2 className="def_hdng_v1 mb-8 ml-auto mr-auto">
                  Gold Bar<span className="grbg_rndd">Information</span>
                </h2>

                {isLoaded ? (
                  goldBarData ? (
                    <>
                      <div className="row">
                        <BoxView
                          title="Gold Bar Id"
                          content={goldBarData.QRCodeSerialNo}
                        />
                        <BoxView
                          title="Total Units"
                          content={goldBarData.grams + ' grams'}
                        />
                        <BoxView
                          title="Available Units"
                          content={`${
                            goldBarData.fetched
                              ? goldBarData.freeUnits
                              : goldBarData.grams
                          } grams`}
                        />
                        <BoxView
                          title="Gold Dealer"
                          content={goldBarData.goldDealer}
                        />
                        <BoxView
                          title="Date Added"
                          content={new Date(goldBarData.date).toDateString()}
                        />
                        <BoxView
                          title="Producer"
                          content={goldBarData.producer}
                        />
                      </div>

                      <TableView owners={goldBarData.owners} />
                    </>
                  ) : (
                    <div className="text-center mx-6">{apiFailMsg}</div>
                  )
                ) : (
                  <div className="text-center mx-6">
                    <ReCAPTCHA
                      sitekey={RECAPTCHA_SITE_KEY}
                      onChange={handleOnchange}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default GoldBarInfo
